"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TRANSFORM_ALIGN = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));

var _styles = require("@material-ui/core/styles");

var _Popover2 = _interopRequireDefault(require("./Popover.css"));

var TRANSFORM_ALIGN = {
  left: 'left',
  right: 'right'
};
exports.TRANSFORM_ALIGN = TRANSFORM_ALIGN;

var Popover =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Popover, _React$PureComponent);

  function Popover() {
    (0, _classCallCheck2.default)(this, Popover);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Popover).apply(this, arguments));
  }

  (0, _createClass2.default)(Popover, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          anchor = _this$props.anchor,
          children = _this$props.children,
          classes = _this$props.classes,
          onClose = _this$props.onClose,
          transform = _this$props.transform;
      var isOpen = Boolean(anchor);
      return React.createElement(_Popover.default, {
        open: isOpen,
        anchorEl: anchor,
        onClose: onClose,
        anchorOrigin: {
          vertical: 'center',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: transform
        },
        PaperProps: {
          classes: {
            root: classes.root
          }
        }
      }, React.createElement("div", {
        className: classes.content
      }, children));
    }
  }]);
  return Popover;
}(React.PureComponent);

Popover.defaultProps = {
  children: null,
  transform: TRANSFORM_ALIGN.left,
  width: null
};
Popover.propType = {
  /**
   * anchor: This is the DOM element, that may be used to set the position of the popover
   */
  anchor: PropTypes.node.isRequired,

  /**
   * children: 	The content of the component
   */
  children: PropTypes.any,

  /**
   * classes: Styles applied to the component
   */
  classes: PropTypes.object.isRequired,

  /**
   * onClose: Callback fired when the component requests to be closed
   */
  onClose: PropTypes.func.isRequired,

  /**
   * transform: This is the horizontal align which will attach to the transformOrigin
   */
  transform: PropTypes.oneOf(Object.keys(TRANSFORM_ALIGN)),

  /**
   * width: The width of the popover content
   */
  width: PropTypes.number
};

var _default = (0, _styles.withStyles)(_Popover2.default)(Popover);

exports.default = _default;